module.exports = __webpack_public_path__ + "static/media/pers-5.c3e2337f.jpg";